import { RecordCreate, RecordUpdate, RecordRemove } from '@app/models/state.model';
import { SectionStateModel, SectionLoad } from '@app/models/state.model';
import { Record } from '@app/models/record.model';
import { Payload } from '@app/models/payload.model';
import { VerificationAnswer } from '@app/models/partials.model';
import { ApplicationNumber } from '@app/models/app.model';

export class LoadSection {
  static readonly type = '[SECTION] Load Section';
  constructor(public payload: SectionLoad) {}
}

export class SetSection {
  static readonly type = '[SECTION] Save Section';
  constructor(public payload: SectionStateModel) {}
}

export class UpdateSection {
  static readonly type = '[SECTION] Update Section';
  constructor(public payload: {applicationNumber: string, sectionId: any, topLevelAnswer: any}) {}
}

export class UpdatePeopleSumSection {
  static readonly type = '[SECTION] Update People Summary Section';
  constructor(public payload: any) {}
}

export class CreateRecord {
  static readonly type = '[SECTION] Create Record';
  constructor(public payload: RecordCreate) {}
}

export class UpdateRecord {
  static readonly type = '[SECTION] Update Record';
  constructor(public payload: RecordUpdate) {}
}

export class RemoveRecord {
  static readonly type = '[SECTION] Remove Record';
  constructor(public payload: RecordRemove) {}
}

export class RemoveDataRecord {
  static readonly type = '[SECTION] Remove Data Record';
  constructor(public payload: {applicationNumber: string, identifier: any, record: any, exportingStatus: any}) {}
}

export class SetRecord {
  static readonly type = '[SECTION] Set Record';
  constructor(public payload: Record) {}
}

export class SaveQuestionnaire {
  static readonly type = '[SECTION] Verify Id';
  constructor(public payload: { applicationNumber: ApplicationNumber; verification: VerificationAnswer }) {}
}

export class HandlePayload {
  static readonly type = '[SECTION] Handle Payload';
  constructor(public payload: Payload) {}
}
